import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth, setTokens } from "../contexts/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// Handles the Emergent Google auth return: exchanges #session_id with the
// backend, stores tokens, then redirects to the dashboard.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = (window.location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    const finish = (path, user) => {
      window.history.replaceState(null, "", window.location.pathname);
      navigate(path, { replace: true, state: user ? { user } : undefined });
    };
    if (!sessionId) { finish("/auth"); return; }
    axios.post(`${API}/auth/google/session`, { session_id: sessionId }, { withCredentials: true })
      .then(res => {
        setTokens(res.data.access_token, res.data.refresh_token);
        setUser(res.data);
        const flow = sessionStorage.getItem("astrofate_mobile_flow");
        const back = sessionStorage.getItem("astrofate_auth_redirect");
        sessionStorage.removeItem("astrofate_auth_redirect");
        const dest = flow && /^[A-Za-z0-9_-]{43}$/.test(flow) ? `/mobile/connect?flow=${flow}`
          : (back && back.startsWith("/") && !back.startsWith("//")) ? back : "/dashboard";
        finish(dest, res.data);
      })
      .catch(() => { setUser(null); finish("/auth"); });
  }, [navigate, setUser]);

  return (
    <div data-testid="auth-callback-loading" className="min-h-screen flex items-center justify-center" style={{ background: "#120021" }}>
      <div style={{ textAlign: "center" }}>
        <div className="animate-spin text-4xl" style={{ color: "#FFD166" }}>✦</div>
        <p style={{ color: "rgba(255,255,255,0.6)", marginTop: "14px", fontSize: "0.9rem" }}>Signing you in…</p>
      </div>
    </div>
  );
}
